import React from "react";

const SectionHeader = ({ children }) => {
  return <h1>{children}</h1>;
};

export default SectionHeader;
